// Consistent colors for participants across the app
// Used by VideoGrid and Subtitles for visual coherence

export const PARTICIPANT_COLORS = [
  { bg: '#dcf8c6', border: '#25D366', name: '#075e54' }, // Green (WhatsApp)
  { bg: '#e3f2fd', border: '#2196f3', name: '#1565c0' }, // Blue
  { bg: '#fff3e0', border: '#ff9800', name: '#e65100' }, // Orange
  { bg: '#f3e5f5', border: '#9c27b0', name: '#7b1fa2' }, // Purple
  { bg: '#ffebee', border: '#f44336', name: '#c62828' }, // Red
  { bg: '#e0f2f1', border: '#009688', name: '#00695c' }, // Teal
  { bg: '#fff8e1', border: '#ffc107', name: '#f9a825' }, // Amber
  { bg: '#fce4ec', border: '#e91e63', name: '#ad1457' }, // Pink
];

// Cache for consistent color assignment
const colorAssignments = new Map();
let nextColorIndex = 1; // Start at 1 so remote participants don't get same color as local (0)

/**
 * Get consistent color for a participant
 * @param {string} peerId - Socket ID of the participant
 * @param {boolean} isLocal - Whether this is the local participant
 * @returns {Object} Color object with bg, border, name properties
 */
export function getParticipantColor(peerId, isLocal = false) {
  if (!peerId) return PARTICIPANT_COLORS[0];

  // Check cache first
  if (colorAssignments.has(peerId)) {
    return colorAssignments.get(peerId);
  }

  // Assign new color
  // Local participant always gets first color (green)
  const colorIndex = isLocal ? 0 : (nextColorIndex++ % PARTICIPANT_COLORS.length);
  const color = PARTICIPANT_COLORS[colorIndex];

  colorAssignments.set(peerId, color);
  return color;
}

/**
 * Reset color assignments (call when leaving meeting)
 */
export function resetParticipantColors() {
  colorAssignments.clear();
  nextColorIndex = 1;
}

/**
 * Pre-assign colors to a list of participants
 * Ensures consistent ordering
 */
export function assignColorsToParticipants(localId, participantIds) {
  // Reset and reassign
  colorAssignments.clear();
  nextColorIndex = 1; // Start from 1, 0 is for local

  // Local first
  if (localId) {
    colorAssignments.set(localId, PARTICIPANT_COLORS[0]);
  }

  // Then others in order
  participantIds.forEach((id) => {
    if (id !== localId && !colorAssignments.has(id)) {
      const color = PARTICIPANT_COLORS[nextColorIndex % PARTICIPANT_COLORS.length];
      colorAssignments.set(id, color);
      nextColorIndex++;
    }
  });
}
